import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--sage-dark)', color: 'white',
      padding: 'clamp(2rem, 5vw, 4rem) clamp(1.5rem, 5vw, 4rem)',
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '2.5rem', marginBottom: '2rem'
      }}>
        {/* Clinic Info */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <img src={logo} alt="Homoeo Care Centre" style={{
              width: '60px', height: '60px',
              borderRadius: '50%', objectFit: 'cover',
              border: '2px solid rgba(255,255,255,0.3)'
            }} />
            <div>
              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontWeight: 700 }}>
                Homoeo Care Centre
              </div>
              <div style={{ fontFamily: 'Jost', fontSize: '0.75rem', opacity: 0.7 }}>
                A Natural Path to Wellness
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {[
              ['📞', '7004760376'],
              ['📞', '8092752200'],
              ['📍', 'Yaduvansh Nagar, Main Road, Fatuha, Patna – 803201'],
              ['🕐', '8:00 AM – 8:00 PM Daily'],
            ].map(([icon, text], i) => (
              <div key={i} style={{ display: 'flex', gap: '0.7rem', alignItems: 'flex-start' }}>
                <span>{icon}</span>
                <span style={{ fontFamily: 'Jost', fontSize: '0.85rem', opacity: 0.85, lineHeight: 1.6 }}>{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Our Doctors */}
        <div>
          <div style={{ fontFamily: 'Jost', fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', opacity: 0.6, marginBottom: '1rem' }}>Our Doctors</div>
          {[
            ['Dr. Arpana Raj', 'Female & Infertility Specialist'],
            ['Dr. Deepak Kapoor', 'Chronic & Complex Disease Specialist'],
          ].map(([name, spec]) => (
            <div key={name} style={{ marginBottom: '1rem' }}>
              <div style={{ fontFamily: 'Jost', fontSize: '0.92rem', fontWeight: 500 }}>{name}</div>
              <div style={{ fontFamily: 'Jost', fontSize: '0.78rem', opacity: 0.65, marginTop: '0.2rem' }}>{spec}</div>
            </div>
          ))}
        </div>

        {/* Quick Links */}
        <div>
          <div style={{ fontFamily: 'Jost', fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', opacity: 0.6, marginBottom: '1rem' }}>Quick Links</div>
          {[['Home', '#home'], ['About', '#about'], ['Services', '#services'], ['Contact', '#contact']].map(([label, href]) => (
            <a key={label} href={href} style={{
              display: 'block', fontFamily: 'Jost', fontSize: '0.9rem',
              opacity: 0.85, marginBottom: '0.5rem', textDecoration: 'none', color: 'white',
            }}>{label}</a>
          ))}
          <Link to="/patient-login" style={{ display: 'block', fontFamily: 'Jost', fontSize: '0.9rem', opacity: 0.85, marginBottom: '0.5rem', textDecoration: 'none', color: 'var(--gold)' }}>Patient Portal</Link>
          <Link to="/login" style={{ display: 'block', fontFamily: 'Jost', fontSize: '0.9rem', opacity: 0.5, textDecoration: 'none', color: 'white' }}>Doctor Login</Link>
        </div>

        {/* Specializations */}
        <div>
          <div style={{ fontFamily: 'Jost', fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', opacity: 0.6, marginBottom: '1rem' }}>We Specialize In</div>
          {['Chronic Diseases', 'Allergies', 'Skin Disorders', 'Child Healthcare', 'Stress & Anxiety', 'Digestive Disorders', "Women's Health", 'Infertility'].map(s => (
            <div key={s} style={{ fontFamily: 'Jost', fontSize: '0.85rem', opacity: 0.75, marginBottom: '0.4rem' }}>• {s}</div>
          ))}
        </div>
      </div>

      {/* Bottom */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.1)',
        paddingTop: '1.5rem',
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: '1rem'
      }}>
        <div style={{ fontFamily: 'Jost', fontSize: '0.8rem', opacity: 0.5 }}>
          © 2025 Homoeo Care Centre. All rights reserved.
        </div>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          {['No Side Effects', 'Natural Healing', 'Safe & Effective'].map(tag => (
            <span key={tag} style={{ fontFamily: 'Jost', fontSize: '0.75rem', opacity: 0.5 }}>✓ {tag}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}
